/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { useDispatch } from 'react-redux';
import { TouchableOpacity } from 'react-native';
import Image from '@components/global/Image';

import { showAlert } from '@/store/global';
import Colors from '@global/colors';

const RemoveImage = ({
  index = undefined,
  data = [],
  copywriting = false,
  setData = () => {},
}) => {
  const dispatch = useDispatch();
  const onRemove = () => {
    dispatch(
      showAlert({
        show: true,
        isModal: true,
        title: copywriting?.title ? copywriting.title : 'Remove Image',
        description: copywriting?.description
          ? copywriting.description
          : 'This image will be removed. Do you want to proceed?',
        testID: 'todo-image-remove',
        onCallback: () => {
          const temp = JSON.parse(JSON.stringify(data));
          if (index !== undefined) {
            temp.splice(index, 1);
          } else {
            setData([temp]);
          }
          setData(temp);
        },
      }),
    );
  };

  return (
    <TouchableOpacity
      testID="todo-image-remove-btn"
      onPress={() => onRemove()}
      activeOpacity={0.6}
      style={{
        width: 20,
        height: 20,
        borderRadius: 25,
        overflow: 'hidden',
        position: 'absolute',
        top: 5,
        right: 5,
        zIndex: 1,
        elevation: 1,
        backgroundColor: Colors.blue1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <Image
        style={{ width: 11, height: 11 }}
        width={11}
        height={11}
        svg={true}
        source={require('@assets/img/icons/close-white.svg')}
      />
    </TouchableOpacity>
  );
};

export default React.memo(RemoveImage, (prev, next) => prev == next);
